(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["contact-form-alt-endpoint"] && !Shopify.designMode) return;
  try {
    (function() {
    var configEl = document.getElementById('contact-alt-endpoint-config');
    if (!configEl) return;

    var altEndpoint = configEl.dataset.altEndpoint;
    var formSelector = configEl.dataset.formSelector || '.contact-form__form';
    var orgId = configEl.dataset.orgId;
    var retUrl = configEl.dataset.retUrl;
    var brandFieldId = configEl.dataset.brandFieldId;
    var brandFieldValue = configEl.dataset.brandFieldValue;

    if (!altEndpoint || !orgId || !retUrl) return;

    function createHiddenInput(form, name, value) {
      if (value == null || value === '') return;
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    }

    function buildSalesforceForm(sourceForm) {
      var sfForm = document.createElement('form');
      sfForm.action = altEndpoint;
      sfForm.method = 'POST';
      sfForm.style.display = 'none';

      var formData = new FormData(sourceForm);
      var email = formData.get('contact[email]');
      var subject = formData.get('subject');
      var body = formData.get('contact[body]');
      var phone = formData.get('contact[phone]');

      createHiddenInput(sfForm, 'email', email);
      createHiddenInput(sfForm, 'subject', subject);
      createHiddenInput(sfForm, 'description', body);
      createHiddenInput(sfForm, 'phone', phone);

      createHiddenInput(sfForm, 'orgid', orgId);
      createHiddenInput(sfForm, 'retURL', retUrl);

      if (brandFieldId && brandFieldValue) {
        createHiddenInput(sfForm, brandFieldId, brandFieldValue);
      }

      createHiddenInput(sfForm, 'external', '1');

      document.body.appendChild(sfForm);
      return sfForm;
    }

    function handleSubmit(event) {
      var form = event.target;

      if (!form || !form.matches(formSelector)) return;

      event.preventDefault();

      var sfForm = buildSalesforceForm(form);
      sfForm.submit();
    }

    document.addEventListener('submit', handleSubmit, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
